// import logo from './logo.svg';
// import React, {Component} from "react";
import React from "react";
import "./App.css";
import "./index.css";

function App() {
  return <div></div>;
}

export default App;
